'use strict';

var AutoEnrolmentType = function () {};

AutoEnrolmentType.EXCLUDE = 0; //Eclude auto enrolment minimum contribution rules
AutoEnrolmentType.INCLUDE = 1; //Include auto enrolment minimum contribution rules

//export for node
if (typeof exports !== 'undefined') {
    if (typeof module !== 'undefined' && module.exports) {
        exports = module.exports = AutoEnrolmentType;
    }
    exports.AutoEnrolmentType = AutoEnrolmentType;
}